import Api from 'utils/api'
import i18n from 'utils/i18n'

export const airlineSlice = ((set, get) => ({
  airlines: [],

  actions: {
    fetchAirlines: async (params) => {
      get().actions.startLoading();
      const api = new Api();
      api.getAirlines(params)
        .then((response) => {
          set((state) => ({ airlines: response.data.airlines }));
          get().actions.stopLoading();
        })
      .catch((err) => {
        get().actions.stopLoading();
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t(err.response.data[0]?.message)})
      });
    }
  }

}))